<template>
  <payment-success v-if="success" />

  <div v-else-if="loading">Loading...</div>

  <div v-else-if="selectedOption?.id">
    <div class="flex items-center">
      <div
        :class="[
          'w-8 h-8 rounded-full bg-white',
          'flex items-center justify-center cursor-pointer',
        ]"
        style="box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1); margin-right: 22px"
        @click="handleGoBack"
      >
        <arrow-back color="#516672" class="w-5 h-5" />
      </div>

      <div class="won-color-green text-2xl font-semibold">
        Securely Checkout
      </div>
    </div>

    <div class="won-blue mt-2.5">Add your new payment info here.</div>

    <div
      class="grid mt-6"
      style="grid-template-columns: 306px auto; gap: 0 32px"
    >
      <div class="pr-8">
        <purchase-option :plan="selectedOption" selected />
      </div>

      <payment-form @payment-form:success="handleSuccess" />
    </div>
  </div>

  <div v-else>
    <div class="font-semibold text-2xl won-modal-paragraph-color">
      Get More Tokens
    </div>

    <div v-if="props.isSettings">
      <div v-if="hasLowTokens" class="text-base won-blue mt-3">
        You’re running low on tokens. Purchase a package to make more generations. Tokens do not expire.
      </div>
      <div v-else-if="hasNoTokens" class="text-base won-blue mt-3">
        You have run out of tokens. Purchase a package to make more generations. Tokens do not expire.
      </div>
    </div>

    <div v-else class="text-base won-blue mt-3">
      Purchase a package to make more generations! Tokens do not expire.
    </div>

    <div
      class="grid md:grid-cols-3 gap-5 mt-12 h-[287px]"
    >
      <purchase-option
        v-for="plan of options"
        :key="plan.title"
        :plan="plan"
        @option:select="handlePurchase"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'

import PurchaseOption from './purchase/option.vue'
import PaymentForm from './purchase/payment-form.vue'
import PaymentSuccess from './purchase/success.vue'

import ArrowBack from '../icons/arrow-back.vue'

import { useTokens } from '../store/token.store'

const props = defineProps({
  isSettings: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['selectedPackage', 'goback'])

const success = ref(false)
const loading = ref(false)

const tokensStore = useTokens()
tokensStore.selectOption()
const { options, selectedOption } = storeToRefs(tokensStore)

if (!options.value?.length) {
  loading.value = true
  tokensStore.initOptions().then(() => (loading.value = false))
}

const { hasLowTokens, hasNoTokens } = storeToRefs(tokensStore)

onMounted(() => {
  let recaptchaScript = document.createElement('script')
  recaptchaScript.setAttribute('src', 'https://js.stripe.com/v3/')
  document.head.appendChild(recaptchaScript)
})

const handleGoBack = () => {
  handlePurchase(null)
  emit('goback')
}

const handlePurchase = (plan) => {
  tokensStore.selectOption(plan)
  emit('selectedPackage')
}

const handleSuccess = async() => {
  tokensStore.refresh()
  loading.value = false
  success.value = true
}
</script>
